import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import logo from "../assets/logo.png";
import dashboardIcon from "../assets/ic_dashboard.svg";
import userListIcon from "../assets/ic_userlist.svg";
import affirmationsIcon from "../assets/ic_business.svg";
import devotionsIcon from "../assets/ic_job.svg";
import prayerGuidesIcon from "../assets/ic_category.svg";
import challengesIcon from "../assets/ic_report.svg";
import downloadIcon from "../assets/ic_change_password.svg";
import logoutIcon from "../assets/ic_logout.png";

const Sidebar = ({ sidebarOpen, onLogout, toggleSidebar }) => {
  const navigate = useNavigate();

    const [confirmDialog, setConfirmDialog] = useState({ open: false, message: "", onConfirm: null });


  const menuItems = [
    { label: "Dashboard", icon: dashboardIcon, path: "/dashboard" },
     "divider",
    { label: "User List", icon: userListIcon, path: "/dashboard/userlist" },
    "divider",
    { label: "Businesses", icon: affirmationsIcon, path: "/dashboard/business" },
    "divider",
    { label: "Jobs", icon: devotionsIcon, path: "/dashboard/jobs" },
    "divider",
    { label: " Categories", icon: prayerGuidesIcon, path: "/dashboard/categories" },
    "divider",
    { label: "Reports", icon: challengesIcon, path: "/dashboard/reports" },
    "divider",
    { label: "Change Password", icon: downloadIcon, path: "/dashboard/changepass" },
    "divider",
  ];

  const handleLogoutClick = () => {
    setConfirmDialog({
      open: true,
      message: "Are you sure you want to logout?",
      onConfirm: () => {
        onLogout();
        navigate("/login");
        setConfirmDialog({ open: false, message: "", onConfirm: null });
      },
    });
  };
  return (
    <>
      {/* Sidebar container */}
      <div
        className={`fixed inset-y-0 left-0 z-30 w-55 bg-[#000000] text-white transform ${
          sidebarOpen ? "translate-x-0" : "-translate-x-full"
        } transition-transform duration-300 ease-in-out md:relative md:translate-x-0`}
      >
        {/* Logo */}
     <div className="flex items-center justify-center h-24 border-b border-white">
 <div className="flex items-center">
  <span className="text-2xl font-extrabold mx-4">Hairgram</span>
</div>

</div>



        {/* Menu */}
        <nav className="flex-1 overflow-y-auto">
          {menuItems.map((item, idx) =>
            item === "divider" ? (
              <div key={idx} className="border-t border-white" />
            ) : (
             <NavLink
  to={item.path}
  key={item.label}
  className={({ isActive }) =>
    `flex items-center gap-2 px-5 py-4 transition-colors ${
      isActive ? "bg-white text-[#000000]" : "text-white hover:bg-white/20"
    }`
  }
  end={item.path === "/dashboard"}
  onClick={() => {
    if (window.innerWidth < 768) toggleSidebar(); // auto close sidebar on mobile after click
  }}
>
  <img
    src={item.icon}
    alt={item.label}
    className={`w-5 h-5 ${item.icon && "transition-colors"} ${
      window.location.pathname === item.path ? "filter invert" : ""
    }`}
  />
  <span className="text-sm font-medium">{item.label}</span>
</NavLink>

            )
          )}

          {/* Logout button */}
          <button
            onClick={handleLogoutClick}
            className="flex items-center gap-3 px-4 py-3  text-white hover:bg-white/20 w-full focus:outline-none"
          >
            <img src={logoutIcon} alt="Logout" className="w-5 h-5" />
            <span className="text-sm font-medium">Logout</span>
          </button>
        </nav>
      </div>

      {/* Overlay to close sidebar on small screens */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black opacity-30 z-20 md:hidden"
          onClick={toggleSidebar} // clicking outside closes sidebar
        />
      )}

       {/* Confirmation Dialog */}
      {confirmDialog.open && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
          <div className="bg-white rounded-lg shadow-lg w-full max-w-md p-6">
            <h2 className="text-lg font-bold text-gray-800">Confirmation</h2>
            <p className="text-gray-600 mt-2">{confirmDialog.message}</p>
            <div className="mt-4 flex justify-end gap-3">
              <button
                onClick={() => setConfirmDialog({ open: false, message: "", onConfirm: null })}
                className="px-4 py-2 border rounded-md text-gray-700 hover:bg-gray-100"
              >
                Cancel
              </button>
              <button
                onClick={confirmDialog.onConfirm}
                className="px-4 py-2 bg-[#000000] text-white rounded-md hover:bg-gray-600"
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Sidebar;
